const olen = (object) => (null === object || void 1 === object ? 0 : Object.entries(object).length);

export default olen;
